import React from 'react';
import { Wifi, WifiOff, LogOut } from 'lucide-react';

export function Header({ user, isOnline, syncQueueLength, onSignOut }) {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6 text-white">
      <div className="flex items-center justify-between mb-2">
        <div>
          <h1 className="text-3xl font-bold">Time Tracker</h1>
          <p className="text-blue-100 mt-1">Welcome, {user.displayName || user.email}</p>
        </div>
        <div className="flex items-center gap-3">
          <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${isOnline ? 'bg-green-500' : 'bg-orange-500'}`}>
            {isOnline ? <Wifi size={16} /> : <WifiOff size={16} />}
            <span className="text-sm font-medium">{isOnline ? 'Online' : 'Offline'}</span>
          </div>
          <button
            onClick={onSignOut}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
            title="Sign out"
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>
      {syncQueueLength > 0 && (
        <div className="mt-2 text-sm bg-orange-500/20 px-3 py-1 rounded">
          {syncQueueLength} item(s) pending sync
        </div>
      )}
    </div>
  );
}
